export default __webpack_public_path__ + "static/media/1_0030.47fabde9.webp";